import React from "react";
import { RightColumn, RightColumnTitle } from "../../../booking/components/FlexContainer";
import { DeleteButton } from "../../../shared/components/Buttons";
import { useTranslation } from "react-i18next";

const EditItemForm = ({ onRemove, onClickBack }) => {
    const { t } = useTranslation();

    return (
        <RightColumn>
            <form onSubmit={(e) => e.preventDefault()} className="">
                <div className="step-header">
                    <RightColumnTitle>{t("booking.roadbook_title")}</RightColumnTitle>
                </div>

                <p>{t("booking.roadbook_app_information")}</p>
                <ul>
                    <li>{t("booking.roadbook_app_information_1")}</li>
                    <li>{t("booking.roadbook_app_information_2")}</li>
                    <li>{t("booking.roadbook_app_information_3")}</li>
                    <li>{t("booking.roadbook_app_information_4")}</li>
                </ul>

                <div>
                    <DeleteButton
                        type="button"
                        className="btn-add-step btn-warning btn-lg"
                        onClick={onRemove}
                    >
                        {t("booking.delete")}
                    </DeleteButton>

                    <p className="cancel-edition">
                        {t("booking.or")}{" "}
                        <a href="#" onClick={onClickBack}>
                            {t("booking.cancel")}
                        </a>
                    </p>
                </div>
            </form>
        </RightColumn>
    );
};
export default EditItemForm;
